import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=f3b73eae&scoped=true"
import script from "./mapping.vue?vue&type=script&lang=js"
export * from "./mapping.vue?vue&type=script&lang=js"
import style0 from "./mapping.vue?vue&type=style&index=0&id=f3b73eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b73eae",
  null
  
)

export default component.exports